<template>
  <div>
    <div v-show="!isEditing">
      <span>{{ displayValue }}</span>
      <button
        v-show="canEdit"
        class="btn btn_sm bg_blue fr"
        @click="$emit('start-edit')"
      >{{ editButtonLabel }}</button>
    </div>
    <div v-show="isEditing">
      <div>
        <slot />
      </div>
      <slot name="warning" />
      <div class="confirm-buttons">
        <button
          class="btn btn_sm bg_danger"
          @click="$emit('confirm')"
        >確定</button>
        <button
          class="btn btn_sm bg_blue"
          @click="$emit('cancel')"
        >キャンセル</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InlineEditCell',
  props: {
    isEditing: {
      type: Boolean,
      required: true,
    },
    displayValue: {
      type: String,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
    editButtonLabel: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  font-size: 16px;
  border-radius: 4px;
  background-color: #00a9ca;
  color: #ffffff;
  padding: 6px 12px;
  cursor: pointer;
}
.btn_sm {
  font-size: 12px;
  padding: 2px 6px;
}
.btn.bg_danger {
  background-color: #d80a0a;
}
.fr {
  float: right;
}
.confirm-buttons {
  margin: 4px 0 0;
}
</style>
